import { jwtDecode } from "jwt-decode"

import { LINKS } from "@api/links.const"
import { useAuthStore } from "@stores/models/auth.store"

import axios from "axios"

axios.defaults.headers.common["Content-Type"] = "application/json"
axios.defaults.headers.common["Accept"] = "application/json"
axios.defaults.withCredentials = true

axios.interceptors.request.use(
  async config => {
    const authStore = useAuthStore()
    const token = authStore.accessToken

    if (
      !token ||
      config.url === LINKS.AUTH.REFRESH() ||
      config.url === LINKS.AUTH.TOKEN.CHECK_IF_EXIST()
    )
      return config

    const { exp } = jwtDecode<{ exp: number }>(token)

    const expiresInMs = exp * 1000 - Date.now()
    const threshold = 60 * 1000 // 1 minute buffer

    if (expiresInMs < threshold) {
      const wasSuccess = await authStore.silentRefresh()
      if (!wasSuccess) throw new axios.Cancel("Silent refresh failed")
    }

    config.headers.Authorization = `Bearer ${authStore.accessToken}`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // const errorResponse = err.response
    // if (errorResponse && errorResponse.status == 401) {
    //   const authStore = useAuthStore()
    //   if (authStore.isAuthenticated) {
    //     authStore.deauthenticate()
    //   }
    // }
    return Promise.reject(error)
  }
)
